
import { useRef } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ResidentialHeroSection from '@/components/ResidentialHeroSection';
import ResidentialPricingSection from '@/components/ResidentialPricingSection';
import ResidentialTrustSection from '@/components/ResidentialTrustSection';
import UseCasesSection from '@/components/UseCasesSection';
import FreeProxyPopup, { FreeProxyPopupRef } from '@/components/FreeProxyPopup';

const ResidentialProxies = () => {
  const freeProxyPopupRef = useRef<FreeProxyPopupRef>(null);

  const handleOpenPopup = () => {
    console.log('Opening popup form directly from header');
    freeProxyPopupRef.current?.openForm();
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ResidentialHeroSection onOpenPopup={handleOpenPopup} />
      <ResidentialPricingSection />
      <UseCasesSection />
      <ResidentialTrustSection />
      <Footer />
      <FreeProxyPopup ref={freeProxyPopupRef} />
    </div>
  );
};

export default ResidentialProxies;
